import { extend } from 'underscore';
import { languageService } from '@core/js/services/language.service';

export * from '@core/js/utils/url.util';

export const formatURL = (url, params, escapingFunctionDefault) => {
    const placeholders = url.match(/[^{}]+(?=\})/g);
    let urlStr = url;

    const escapingFunction = escapingFunctionDefault || window.encodeURIComponent;

    if (!placeholders) {
        return urlStr;
    }

    if (params) {
        for (const param in params) {
            if (params[param]) {
                urlStr = urlStr.split(`{${param}}`).join(escapingFunction(params[param]));
            }
        }
    }

    return urlStr;
};

export const getFormattedUrl = (url, userData, options) => {
    const params = extend({}, userData, options);

    return formatURL(url, params);
};

export const getFormattedUrlAsync = async (url, userData, appData, getTempToken, options = {}) => {
    const asyncParams = ['{tempToken}'];
    const foundAsyncParams = asyncParams.filter(param => url.includes(param));
    const promises = [];

    foundAsyncParams.forEach((param) => {
        switch (param) {
            case '{tempToken}': {
                promises.push(getTempToken().then(tempToken => tempToken?.data?.sessionToken?.sessionToken));

                break;
            }
            default: promises.push(true);
        }
    });

    return Promise.all(promises).then(results => {
        const additionalParams = {
            casinoName: appData.casinoName,
            clientSkin: appData.casinoSkin,
            clientType: appData.clientType,
            clientVersion: appData.clientVersion,
            clientPlatform: appData.clientPlatform,
            lang: languageService.getTwoLetterLanguage(userData.lang)
        };

        foundAsyncParams.forEach((param, index) => {
            switch (param) {
                case '{tempToken}': additionalParams.tempToken = results[index]; break;
                default: additionalParams[param] = results[index];
            }
        });

        return getFormattedUrl(url, userData, {
            ...additionalParams,
            ...options
        });
    });
};
